module.exports = __webpack_public_path__ + "img/60-61-2.aac65315.png";